/* TWG: derive every classic Bundler heading from its current totals. */
(() => {
  'use strict';
  if (window.twgBundlerSavingsInstalled) return;
  window.twgBundlerSavingsInstalled = true;
  const containerSelector = '.bndlr-products-container';
  const priceSelector = '.bndlr-total-price';
  let queued = false;
  const currency = document.getElementById('twg-bundler-savings')?.dataset.currency || 'USD';
  const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 2
  });
  function cents(element) {
    const raw = element?.getAttribute('data-currentprice');
    if (raw == null || raw.trim() === '') return null;
    const value = Number(raw);
    return Number.isFinite(value) && value >= 0 ? Math.round(value) : null;
  }
  function refresh() {
    queued = false;
    document.querySelectorAll(containerSelector).forEach(widget => {
      const title = widget.querySelector('.bndlr-bundle-title');
      if (!title) return;
      const totals = widget.querySelector(priceSelector);
      const original = cents(totals?.querySelector('.bndlr-old-price'));
      const discounted = cents(totals?.querySelector('.bndlr-new-price'));
      const saving = original !== null && discounted !== null ? original - discounted : 0;
      const heading = saving > 0 ? 'Bundle and Save ' + formatter.format(saving / 100) + '!' : 'Bundle and Save!';
      if (title.textContent !== heading) title.textContent = heading;
      title.setAttribute('data-twg-savings-ready', 'true');
    });
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(refresh);
  }
  function relevant(node) {
    const element = node.nodeType === 1 ? node : node.parentElement;
    return !!element && (element.matches(containerSelector) || element.closest(containerSelector) ||
      element.querySelector(containerSelector));
  }
  function start() {
    refresh();
    new MutationObserver(records => {
      if (records.some(record => {
        if (record.type === 'attributes') return !!record.target.closest(priceSelector);
        if (record.type === 'characterData') return relevant(record.target);
        return relevant(record.target) ||
          [...record.addedNodes, ...record.removedNodes].some(relevant);
      })) schedule();
    }).observe(document.body, {
      subtree: true, childList: true, characterData: true, attributes: true,
      attributeFilter: ['data-currentprice']
    });
    document.addEventListener('change', event => {
      if (event.target.closest(containerSelector)) schedule();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();